//#region libraries
import React, { useCallback, useEffect, useState } from 'react'
//bootstrap
import { Button, Col, Form, Row } from 'react-bootstrap'
//tremor
import { Flex, List, ListItem, Subtitle } from "@tremor/react";
//redux
import { useDispatch, useSelector } from 'react-redux';
import { assignEmployeesWorkZone, removeWorkzoneEmployees, selectAssignEmployeesWorkZoneStatus, selectRemoveWorkzoneEmployeesStatus } from '_redux/slices/timeline/employees';
import { selectSelectedTimeline } from '_redux/slices/timeline/timeline-areas';
//custom component
import { Card, SearchBar } from '_components/atoms';
import { Spacing } from '_styles';

//#endregion

// employee row in list component
const EmployeeRow = React.memo(({ employee, assigningEmployee, removedEmployees, handleAssignEmployee, handleRemoveEmployee, handleCheckIfAssigned, assignedEmployees }) => {
  return (
    <ListItem>
      <Flex>
        <div style={{ display: "flex" }}>
          <div
            className="mt-2"
            style={{
              height: 12,
              width: 12,
              backgroundColor: employee?.status == "online" ? "green" : "red", //TODO, improve bg color
              borderRadius: 50,
              marginLeft: 12,
              marginInlineEnd: "12px",
            }}
          />
          <div >
            <p style={{ fontSize: 14, fontWeight: "400", textAlign: "left", marginTop: Spacing.SCALE_4, color: "black" }}>
              {employee?.title ?? ""}
            </p>
            <p style={{ opacity: 0.4, marginTop: -Spacing.SCALE_12, fontSize: 10 }}>{employee?.employeeId}</p></div>

        </div>

        {assigningEmployee ?

          // employee is assigned    
          <div style={{ display: 'flex' }}>
            <Form.Check
              onChange={(e) => { handleAssignEmployee(employee, e.target.checked) }}
              type="checkbox"
              defaultChecked={false}
              checked={handleCheckIfAssigned(assignedEmployees, employee, "assigning")}
            />
          </div>

          :

          // employee has not been assigned
          <div style={{ display: 'flex' }}>
            <Form.Check
              onChange={(e) => { handleRemoveEmployee(employee) }}
              type="checkbox"
              defaultChecked={false}
              checked={handleCheckIfAssigned(removedEmployees, employee, "removing")}
            />
          </div>
        }
      </Flex>
    </ListItem>
  )
}
)

const EmployeesListCard = (props) => {

  //redux
  const dispatch = useDispatch()

  const selectedTimeline = useSelector(selectSelectedTimeline);                                   // current selected time line
  const assignedEmployeesStatus = useSelector(selectAssignEmployeesWorkZoneStatus);              // status after assign employee/s to timeline
  const removeWorkzoneEmployeesStatus = useSelector(selectRemoveWorkzoneEmployeesStatus);       // flag after dispatch remove employee/s from timeline

  //#region states
  const [assignedEmployees, setAssignedEmployees] = useState([]);//employees assigned for each timeline
  const [removedEmployees, setRemovedEmployees] = useState([]);//selected employees who will be remove from timeline
  const [searchEmployees, setSearchEmployees] = useState("")//value of input search   
  //#endregion

  //#region use effects

  // on selected timeline change, get the employees assigned to the timeline
  useEffect(() => {
    if (!Object.isObjectEmpty(selectedTimeline) && Array.isFullArray(props.employees)) {
      let tempEmployees = [...props.employees];
      tempEmployees = tempEmployees.filter((employee) => employee?.workZone?._id === selectedTimeline?._id);
      setAssignedEmployees(tempEmployees);
    }
  }, [selectedTimeline, props.employees]);
  //#endregion

  // check if employee is selected
  const handleCheckIfSelected = (assignedOrRemovedEmployees, currentEmp, typeChecking) => {

    // create list of employees 
    let tempEmployees = assignedOrRemovedEmployees?.filter((employee) => employee?.employeeId === currentEmp?.employeeId);

    // check employee list exists
    if (tempEmployees.length) {
      if (typeChecking === "removing") {
        return tempEmployees[0].workZone
      } else {
        return tempEmployees[0]?.workZone?._id === selectedTimeline?._id ? true : false;
      }
    }

    return false;

  };

  //#region employees function

  //add checked employee to selected workzone
  const handleAssignEmployee = useCallback((employee, toAssign) => {
    setAssignedEmployees((prev) => [
      ...prev.filter((AssignedEmployee) => AssignedEmployee?.employeeId !== employee?.employeeId),
      {
        ...employee,
        workZone: toAssign ? selectedTimeline : null,
      }
    ]);
  }, [setAssignedEmployees, selectedTimeline]);

  //update checked employee with workzone->null
  const handleRemoveEmployee = useCallback((employee) => {
    setRemovedEmployees((prev) => [
      ...prev.filter((removedEmployee) => removedEmployee?.employeeId !== employee?.employeeId),
      {
        ...employee,
        workZone: null,
      }]);
  }, [setRemovedEmployees, selectedTimeline]);

  //#endregion

  // assign / remove button under employees list
  const ActionButton = ({ type, data, status }) => {

    // button press handler
    const handleButtonPress = () => {
      // check if type is assign or type is remove
      if (type == 'Assign') {
        handleAssign();
      }
      else {
        handleRemove();
      }
    }

    const handleAssign = () => {

      dispatch(assignEmployeesWorkZone(
        data?.filter((employee) => employee?.workZone?._id === selectedTimeline?._id || props.employees?.map((element) => element?.employeeId)?.includes(employee?.employeeId)))
      )
    }

    const handleRemove = () => {
      dispatch(removeWorkzoneEmployees(
        data?.filter((employee) => employee?.workZone?._id === selectedTimeline?._id || props.employees
          ?.map((element) => element?.employeeId)
          ?.includes(employee?.employeeId))))
    }

    return (
      <div style={{ display: "flex" }}>
        <Button
          onClick={() => handleButtonPress()}
          variant="primary"
          style={{ marginBlock: "20px" }}
        >
          {status === "loading" ? "loading" : type}
        </Button>
      </div>
    )
  }

  return (
    <Row>
      <Col xs={3} md={12}>
        <Card devOverFlowY={true} devMaxHeight={true}>

          {/* subtitle + search bar */}
          <Flex>
            <Subtitle >{props.listTitle}</Subtitle>

            {props.approvedEmployee &&
              <SearchBar
                onChange={(e) => {
                  props?.handleSearch(e.target.value);
                  setSearchEmployees(e.target.value)
                }}
                placeholder={`Search for an employee`}
                value={searchEmployees} />
            }
          </Flex>

          <List>
            {Array.isFullArray(props.employees) && props.employees.map((employee => {
              return (
                <EmployeeRow
                  approvedEmployee={props.approvedEmployee}
                  employee={employee}
                  assigningEmployee={props.assigningEmployee}
                  key={employee.employeeId}
                  handleAssignEmployee={handleAssignEmployee}
                  handleRemoveEmployee={handleRemoveEmployee}
                  handleCheckIfAssigned={handleCheckIfSelected}
                  assignedEmployees={assignedEmployees}
                  removedEmployees={removedEmployees}
                />
              )
            }))}
          </List>
        </Card>

        {/* assign button under employee list */}
        {props.approvedEmployee && <ActionButton type="Assign" data={assignedEmployees} status={assignedEmployeesStatus} />}

        {/* remove button under employees of timeline */}
        {props.assignedEmployees && <ActionButton type="Remove" data={removedEmployees} status={removeWorkzoneEmployeesStatus} />}

      </Col>
    </Row>
  )
}

export default EmployeesListCard
